import { render, staticRenderFns } from "./PointExpireConfigHistory.vue?vue&type=template&id=b4efa4d2"
import script from "./PointExpireConfigHistory.vue?vue&type=script&lang=js"
export * from "./PointExpireConfigHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports